import { Container } from '@/ui-kit';
import styles from './premium-list.module.scss';
import { PremiumItem } from './components/premium-item';
import { Tariff } from '@/types/tariff';
interface Props {
    tariffs?: Tariff[];
    tariffActiveId?: number;
    onChangeTariff: (id: number) => void;
}
export const PremiumList: React.FC<Props> = ({ tariffs, tariffActiveId, onChangeTariff }) => {
    return (
        <Container className={styles.container}>
            <div className={styles.premiumList}>
                {tariffs?.map((tariff) => (
                    // TODO: transfer isProfit/priceInRub/discount props
                    <PremiumItem
                        onClick={() => onChangeTariff(tariff.id)}
                        key={tariff.id}
                        price={tariff.amount}
                        date={tariff.title}
                        isActive={tariff.id === tariffActiveId}
                        priceInRub={tariff.price_rub}
                        isProfit={tariff.profitable}
                        discount={tariff.discount} />
                ))}
            </div>
            <span className={styles.notice}>
                *Цена в ₽ ориентировочна, зависит от курса Telegtam Stars
            </span>
        </Container>
    );
};
